import { checkPropTypes } from 'prop-types'
import React from 'react'

export default function EyeIcon({ styles, width, height }) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 21C23.206 21.0052 22.4459 21.323 21.8845 21.8845C21.323 22.4459 21.0052 23.206 21 24C21 25.642 22.358 27 24 27C25.641 27 27 25.642 27 24C27 22.359 25.641 21 24 21Z"
        fill="#565656"
      />
      <path
        d="M14.3828 24.3465C14.4015 24.3975 14.43 24.4688 14.469 24.5602C14.5717 24.801 14.6933 25.0522 14.8298 25.3073C15.129 25.8667 15.6488 26.7112 16.4265 27.5565C18.4088 29.709 20.9865 30.8002 24.0893 30.8002C27.1927 30.8002 29.7705 29.709 31.7528 27.5565C32.529 26.7127 33.0495 25.8675 33.3495 25.308C33.4837 25.0568 33.6053 24.8055 33.7103 24.5595C33.7478 24.4703 33.777 24.3982 33.795 24.348L33.9053 24.0247L33.7957 23.7022C33.7778 23.6527 33.7485 23.5807 33.7103 23.4908C33.606 23.247 33.4845 22.995 33.3503 22.743C33.0502 22.1827 32.529 21.3383 31.7528 20.4945C29.772 18.342 27.1935 17.25 24.09 17.25C20.9858 17.25 18.408 18.342 16.4265 20.4945C15.651 21.3375 15.1305 22.1827 14.8298 22.743C14.658 23.064 14.5387 23.3265 14.469 23.4908C14.4307 23.5815 14.4023 23.6535 14.3835 23.703L14.37 23.739L14.25 23.7405L14.3573 23.775L14.2732 24.0255L14.3828 24.3465ZM15.957 23.9355C16.482 22.731 18.618 18.8002 24.09 18.8002C29.5605 18.8002 31.698 22.731 32.223 23.9355L32.2612 24.0255L32.223 24.114C31.698 25.3193 29.5627 29.25 24.09 29.25C18.6172 29.25 16.482 25.3193 15.957 24.1147L15.918 24.0247L15.957 23.9355Z"
        fill="#565656"
      />
    </svg>
  )
}

EyeIcon.propTypes = {
  styles: checkPropTypes.any,
  width: checkPropTypes.string,
  height: checkPropTypes.string,
}
